import React, { Component } from 'react'
import { ReactComponent as PlayBtn } from '../../../icons/play-button.svg'
import { extend } from '../../../utils/classes'

export class Video extends Component {
  handleClick = () => {
    const { setShowVideo } = this.props
    setShowVideo(true)
  }

  render() {
    const { parentClass } = this.props
    const baseClass = extend(parentClass, 'play-video')
    const iconClass = extend(baseClass, 'icon')
    return (
      <button className={baseClass} onClick={this.handleClick}>
        <span className={iconClass}>
          <PlayBtn className={extend(iconClass, 'svg')} />
        </span>
        Play Video
      </button>
    )
  }
}

export default Video
